import React, { useState } from 'react';
import { Row, Col } from 'antd';
import { toast } from 'react-toastify';

function Form({ des }) {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  const validate = () => {
    const { first_name, last_name, email, phone, message } = formData;

    if (!first_name || first_name.length < 2) {
      toast.error("First name must be at least 2 characters.");
      return false;
    }
    if (!last_name || last_name.length < 2) {
      toast.error("Last name must be at least 2 characters.");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.");
      return false;
    }
    const phoneRegex = /^[0-9]{10,15}$/;
    if (!phoneRegex.test(phone)) {
      toast.error("Phone number must be 10–15 digits.");
      return false;
    }
    if (!message || message.length < 10) {
      toast.error("Message must be at least 10 characters.");
      return false;
    }
    return true;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}api/inquiry`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(data.data?.message || "Message sent successfully!");
        setFormData({ first_name: '', last_name: '', email: '', phone: '', message: '' });
      } else {
        toast.error(data.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Network error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="space-y-6 font-outfit" onSubmit={handleSubmit}>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <label className="block mb-1 text-sm font-semibold">First Name</label>
          <input
            type="text"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            placeholder="Enter Your First Name ..."
            className="w-full p-3 rounded-lg border border-gray-600 bg-transparent text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </Col>
        <Col xs={24} md={12}>
          <label className="block mb-1 text-sm font-semibold">Last Name</label>
          <input
            type="text"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            placeholder="Enter Your Last Name ..."
            className="w-full p-3 rounded-lg border border-gray-600 bg-transparent text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </Col>
        <Col xs={24} md={12}>
          <label className="block mb-1 text-sm font-semibold">Email Address</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter Your Email Address ..."
            className="w-full p-3 rounded-lg border border-gray-600 bg-transparent text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </Col>
        <Col xs={24} md={12}>
          <label className="block mb-1 text-sm font-semibold">Phone Number</label>
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Enter Your Phone Number ..."
            className="w-full p-3 rounded-lg border border-gray-600 bg-transparent text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </Col>
      </Row>

      <div>
        <label className="block mb-1 text-sm font-semibold">Message</label>
        <textarea
          name="message"
          rows="5"
          value={formData.message}
          onChange={handleChange}
          placeholder="Enter Your Message ..."
          className="w-full p-3 rounded-lg border border-gray-600 bg-transparent text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
        ></textarea>
      </div>

      <p className="text-sm text-gray-400">{des}</p>

      <button
        type="submit"
        disabled={loading}
        className="bg-[linear-gradient(90deg,_rgba(67,170,214,1)_10%,_rgba(0,0,0,1)_100%)] text-white px-6 py-3 rounded-full hover:opacity-90 transition-all"
      >
        {loading ? 'Submitting...' : 'Submit'}
      </button>
    </form>
  );
}

export default Form;
